import { AppState } from "store/rootReducer";
import { createSelector } from "reselect";

const emailSchedulerDefinitionState = (state: AppState) => state.emailScheduler.definition;

export const getEmailSchedulerDefinitionProcessingState = createSelector(
    emailSchedulerDefinitionState,
    ({ isProcessing, hasError, isSubmitted }) => ({ isProcessing, hasError, isSubmitted })
);

export const getEmailSchedulerDefinitions = createSelector(
    emailSchedulerDefinitionState,
    ({ deadlines, templates, statuses, exceptions }) => ({ deadlines, templates, statuses, exceptions })
);

export const getSortedExceptions = createSelector(emailSchedulerDefinitionState, ({ exceptions }) =>
    exceptions
        .sort((a, b) => {
            if (a.name.toLowerCase() > b.name.toLowerCase()) {
                return 1;
            }

            if (b.name.toLowerCase() > a.name.toLowerCase()) {
                return -1;
            }

            return 0;
        })
        .map(({ name }) => name)
);

export const getRuleEditProperties = createSelector(emailSchedulerDefinitionState, ({ properties }) => properties);

export const getExceptionById = (id?: string) =>
    createSelector(emailSchedulerDefinitionState, ({ exceptions }) => {
        return exceptions.find(({ name }) => name === id);
    });

export const getExceptions = createSelector(emailSchedulerDefinitionState, ({ exceptions }) => exceptions);
